import { createSlice } from "@reduxjs/toolkit";
import { claimListDatMiddleWare, claimListSearchDataDatMiddleWare } from "./claimMiddleWare";
import SvgArrow from "../../../assets/icons/SvgArrow";

const initialState = {
    loading: false,
    error: "",
    claimsTabelList: [
        {
            id: "1",
            claimNumber: "CLM-2025-MOT-001",
            ClientName: "Juan Dela Cruz",
            policyNumber: "MIC-2025-MOT-00123",
            Date: "28 MAR 2025",
            ProductDescription: "Motor Comprehensive",
            ClaimType: "Collision",
            ClaimAmount: "₱85,000",
            DateOfLoss: "25 MAR 2025",
            InsuranceCompany: "Malayan Insurance",
            Status: "Under Assessment",
            Actions: <SvgArrow />,
        },
        {
            id: "2",
            claimNumber: "CLM-2025-FIRE-002",
            ClientName: "SM Prime Holdings",
            policyNumber: "PIC-2025-FIRE-00456",
            Date: "27 MAR 2025",
            ProductDescription: "Fire & Allied Perils",
            ClaimType: "Typhoon Damage",
            ClaimAmount: "₱2,500,000",
            DateOfLoss: "20 MAR 2025",
            InsuranceCompany: "Pioneer Insurance",
            Status: "Documents Required",
            Actions: <SvgArrow />,
        },
        {
            id: "3",
            claimNumber: "CLM-2025-PA-003",
            ClientName: "Maria Santos",
            policyNumber: "AXA-2025-PA-00789",
            Date: "26 MAR 2025",
            ProductDescription: "Personal Accident",
            ClaimType: "Medical Reimbursement",
            ClaimAmount: "₱35,000",
            DateOfLoss: "22 MAR 2025",
            InsuranceCompany: "AXA Philippines",
            Status: "Approved",
            Actions: <SvgArrow />,
        },
        {
            id: "4",
            claimNumber: "CLM-2025-MOT-004",
            ClientName: "Roberto Reyes",
            policyNumber: "PGA-2025-MOT-00234",
            Date: "25 MAR 2025",
            ProductDescription: "Motor CTPL",
            ClaimType: "Third Party Injury",
            ClaimAmount: "₱100,000",
            DateOfLoss: "23 MAR 2025",
            InsuranceCompany: "PGA Sompo",
            Status: "Processing",
            Actions: <SvgArrow />,
        },
        {
            id: "5",
            claimNumber: "CLM-2025-MAR-005",
            ClientName: "2GO Group Inc.",
            policyNumber: "CPA-2025-MAR-00567",
            Date: "24 MAR 2025",
            ProductDescription: "Marine Cargo",
            ClaimType: "Cargo Damage",
            ClaimAmount: "₱450,000",
            DateOfLoss: "20 MAR 2025",
            InsuranceCompany: "Charter Ping An",
            Status: "Under Investigation",
            Actions: <SvgArrow />,
        },
        {
            id: "6",
            claimNumber: "CLM-2025-HLT-006",
            ClientName: "Ana Garcia",
            policyNumber: "MAX-2025-HLT-00890",
            Date: "23 MAR 2025",
            ProductDescription: "Health Insurance",
            ClaimType: "Hospitalization",
            ClaimAmount: "₱125,000",
            DateOfLoss: "18 MAR 2025",
            InsuranceCompany: "Maxicare",
            Status: "Settled",
            Actions: <SvgArrow />,
        },
        {
            id: "7",
            claimNumber: "CLM-2025-MOT-007",
            ClientName: "Pedro Gonzales",
            policyNumber: "FPG-2025-MOT-00345",
            Date: "22 MAR 2025",
            ProductDescription: "Commercial Vehicle",
            ClaimType: "Theft",
            ClaimAmount: "₱850,000",
            DateOfLoss: "21 MAR 2025",
            InsuranceCompany: "FPG Insurance",
            Status: "Police Report Pending",
            Actions: <SvgArrow />,
        },
        {
            id: "8",
            claimNumber: "CLM-2025-TRV-008",
            ClientName: "Carmen Bautista",
            policyNumber: "STD-2025-TRV-00456",
            Date: "21 MAR 2025",
            ProductDescription: "Travel Insurance",
            ClaimType: "Trip Cancellation",
            ClaimAmount: "₱15,000",
            DateOfLoss: "20 MAR 2025",
            InsuranceCompany: "Standard Insurance",
            Status: "Approved",
            Actions: <SvgArrow />,
        },
        {
            id: "9",
            claimNumber: "CLM-2025-FIRE-009",
            ClientName: "Ayala Corporation",
            policyNumber: "MIC-2025-FIRE-00678",
            Date: "20 MAR 2025",
            ProductDescription: "Industrial All Risk",
            ClaimType: "Equipment Breakdown",
            ClaimAmount: "₱3,200,000",
            DateOfLoss: "15 MAR 2025",
            InsuranceCompany: "Malayan Insurance",
            Status: "Adjuster Assigned",
            Actions: <SvgArrow />,
        },
        {
            id: "10",
            claimNumber: "CLM-2025-MOT-010",
            ClientName: "Miguel Torres",
            policyNumber: "ORI-2025-MOT-00789",
            Date: "19 MAR 2025",
            ProductDescription: "Motorcycle Insurance",
            ClaimType: "Own Damage",
            ClaimAmount: "₱25,000",
            DateOfLoss: "18 MAR 2025",
            InsuranceCompany: "Oriental Assurance",
            Status: "Repair Approval",
            Actions: <SvgArrow />,
        },
    ],
    claimSeachData: []
}

const claimReducers = createSlice({
    name: "claims",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(claimListDatMiddleWare.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(claimListDatMiddleWare.fulfilled, (state, action) => {
            state.loading = false;
            state.claimsTabelList = action.payload;
        });
        builder.addCase(claimListDatMiddleWare.rejected, (state, action) => {
            state.loading = false;
            state.claimsTabelList = {};
            state.error = typeof action.payload === "string" ? action.payload : "";
        });


        builder.addCase(claimListSearchDataDatMiddleWare.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(claimListSearchDataDatMiddleWare.fulfilled, (state, action) => {
            state.loading = false;
            state.claimSeachData = action.payload;
        });
        builder.addCase(claimListSearchDataDatMiddleWare.rejected, (state, action) => {
            state.loading = false;
            state.claimSeachData = {};
            state.error = typeof action.payload === "string" ? action.payload : "";
        });
    }
})

export default claimReducers.reducer